import { render } from "./PageEditSensor.vue?vue&type=template&id=2e906ba2"
import script from "./PageEditSensor.vue?vue&type=script&lang=js"
export * from "./PageEditSensor.vue?vue&type=script&lang=js"
script.render = render

export default script